import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const TwitterCard = ({ twitter: username, title, description, image, domain }) => (
  <Helmet>
    {/* Twitter Card tags */}
    <meta name="twitter:card" content="summary_large_image"/>
    <meta name="twitter:creator" content={username}/>
    <meta name="twitter:title" content={title}/>
    <meta name="twitter:description" content={description}/>
    <meta name="twitter:image" content={image}/>
    <meta name="twitter:domain" content={domain}/>
  </Helmet>
);

TwitterCard.propTypes = {
  twitter: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string,
  domain: PropTypes.string.isRequired,
};

export default TwitterCard;


// WEBPACK FOOTER //
// ./src/components/Head/TwitterCard.js